import HeadingIcon from 'material-ui/svg-icons/editor/title';
import TextIcon from 'material-ui/svg-icons/editor/text-fields';
import ButtonIcon from 'material-ui/svg-icons/action/touch-app';
import ImageIcon from 'material-ui/svg-icons/image/image';
import ImageAndTextIcon from 'material-ui/svg-icons/device/wallpaper';
import FAQIcon from 'material-ui/svg-icons/action/question-answer';
import MovieIcon from 'material-ui/svg-icons/av/videocam';
import ContactIcon from 'material-ui/svg-icons/communication/contact-mail';

import Heading from './Heading';
import Text from './Text';
import Button from './Button';
import Image from './Image';
import ImageAndText from './ImageAndText';
import FAQ from './FAQ';
import Youtube from './Youtube';
import ContactForm from './ContactForm';

export const lookupTable = {
  heading: {
    title: 'Heading',
    icon: HeadingIcon,
  },
  text: {
    title: 'Text',
    icon: TextIcon,
  },
  button: {
    title: 'Button',
    icon: ButtonIcon,
  },
  image: {
    title: 'Image',
    icon: ImageIcon,
  },
  imageAndText: {
    title: 'Image with text',
    icon: ImageAndTextIcon,
  },
  faq: {
    title: 'FAQ',
    icon: FAQIcon,
  },
  youtube: {
    title: 'Youtube',
    icon: MovieIcon,
  },
  contactForm: {
    title: 'Contact form',
    icon: ContactIcon,
  },
};

export default {
  heading: Heading,
  text: Text,
  button: Button,
  image: Image,
  imageAndText: ImageAndText,
  faq: FAQ,
  youtube: Youtube,
  contactForm: ContactForm,
};
